
import React from 'react';

const OurPeopleCardPhone = (props) => {
    return (
        <a href={`tel:${props.phone.replace(/\s+/g, '')}`}>{props.phone}</a>
    );
}

export default OurPeopleCardPhone;